const FILE_ID_PATTERNS = [
  /\/file\/d\/([a-zA-Z0-9_-]+)/,
  /\/d\/([a-zA-Z0-9_-]+)/,
  /[?&]id=([a-zA-Z0-9_-]+)/,
];

/** Normalize a download link: keep GitHub/direct URLs; convert Google Drive share links. */
export const toDriveDownloadUrl = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return '';

  if (/^https?:\/\//i.test(raw)) {
    if (!/drive\.google\.com/i.test(raw)) {
      return raw;
    }
  }

  let fileId = '';
  for (const pattern of FILE_ID_PATTERNS) {
    const match = raw.match(pattern);
    if (match && match[1]) {
      fileId = match[1];
      break;
    }
  }
  if (!fileId && /^[a-zA-Z0-9_-]{20,}$/.test(raw)) {
    fileId = raw;
  }
  if (!fileId) return '';
  return `https://drive.google.com/uc?export=download&id=${fileId}`;
};

export const parseDriveLinkFile = (text) => {
  const links = {};
  String(text || '').split(/\r?\n/).forEach((line) => {
    const trimmed = line.trim();
    if (!trimmed || trimmed.startsWith('#')) return;
    const eq = trimmed.indexOf('=');
    if (eq < 1) return;
    const key = trimmed.slice(0, eq).trim();
    const value = trimmed.slice(eq + 1).trim();
    const url = toDriveDownloadUrl(value);
    if (url) links[key] = url;
  });
  return links;
};
